(function () {
  var MAX_PAGES = 20;

  function syncHeadings(list) {
    list.querySelectorAll('.system-component-heading').forEach(function (heading) {
      var next = heading.nextElementSibling;
      var visible = false;
      while (next && !next.classList.contains('system-component-heading')) {
        if (
          next.classList.contains('product-column') &&
          !next.hidden &&
          next.getAttribute('data-collapsed') !== 'true'
        ) {
          visible = true;
          break;
        }
        next = next.nextElementSibling;
      }
      heading.hidden = !visible;
    });
  }

  function columnHasFinish(column, finish) {
    if (!finish) return true;
    var raw = column.getAttribute('data-product-finishes') || '';
    return raw.split('|').some(function (item) {
      return item.trim().toLowerCase() === finish;
    });
  }

  function currentFinish(root) {
    var select = root.querySelector('[data-system-product-finish]');
    return select ? select.value.trim().toLowerCase() : '';
  }

  function readPriority(list) {
    return (list.getAttribute('data-component-priority') || '')
      .split('|')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function componentName(column) {
    return (column.getAttribute('data-system-component') || '').trim();
  }

  function compareComponents(aName, bName, priority) {
    function rank(name) {
      var key = (name || '').trim().toLowerCase();
      if (!key) return { tier: 2, index: 0, key: '' };
      for (var i = 0; i < priority.length; i++) {
        if (priority[i].toLowerCase() === key) return { tier: 0, index: i, key: key };
      }
      return { tier: 1, index: 0, key: key };
    }

    var a = rank(aName);
    var b = rank(bName);
    if (a.tier !== b.tier) return a.tier - b.tier;
    if (a.tier === 0 && a.index !== b.index) return a.index - b.index;
    return a.key.localeCompare(b.key);
  }

  function ensureIndexes(list) {
    var max = 0;
    list.querySelectorAll(':scope > .product-column').forEach(function (column) {
      var current = Number(column.dataset.originalIndex);
      if (current) max = Math.max(max, current);
    });
    list.querySelectorAll(':scope > .product-column').forEach(function (column) {
      if (!column.dataset.originalIndex) {
        max += 1;
        column.dataset.originalIndex = String(max);
      }
    });
  }

  function buildHeading(label) {
    var heading = document.createElement('div');
    heading.className = 'f-column system-component-heading';
    var title = document.createElement('h3');
    title.className = 'h4';
    title.textContent = label;
    heading.appendChild(title);
    return heading;
  }

  function ensureHeadings(list) {
    var ungrouped = list.getAttribute('data-ungrouped-label') || 'Other';
    list.querySelectorAll(':scope > .system-component-heading').forEach(function (heading) {
      heading.remove();
    });
    var lastKey = null;
    list.querySelectorAll(':scope > .product-column').forEach(function (column) {
      var name = componentName(column);
      var key = name.toLowerCase();
      if (key !== lastKey) {
        column.before(buildHeading(name || ungrouped));
        lastKey = key;
      }
    });
  }

  function regroup(list) {
    ensureIndexes(list);
    var priority = readPriority(list);
    var products = Array.from(list.querySelectorAll(':scope > .product-column'));
    var sorted = products.slice().sort(function (a, b) {
      var byName = compareComponents(componentName(a), componentName(b), priority);
      if (byName !== 0) return byName;
      return (Number(a.dataset.originalIndex) || 0) - (Number(b.dataset.originalIndex) || 0);
    });
    var same = sorted.every(function (column, index) {
      return column === products[index];
    });

    if (!same) {
      var extras = Array.from(list.children).filter(function (node) {
        return !node.classList.contains('product-column') && !node.classList.contains('system-component-heading');
      });
      list.querySelectorAll(':scope > .system-component-heading').forEach(function (heading) {
        heading.remove();
      });
      sorted.forEach(function (column) {
        list.appendChild(column);
      });
      extras.forEach(function (node) {
        list.appendChild(node);
      });
    }

    ensureHeadings(list);
  }

  function updateShowMore(root) {
    var list = root.querySelector('#ProductsList');
    var button = root.querySelector('[data-system-show-more]');
    if (!list || !button) return;
    var finish = currentFinish(root);
    var hasCollapsed = Array.from(list.querySelectorAll('.product-column[data-collapsed]')).some(function (column) {
      return columnHasFinish(column, finish);
    });
    var hasNext = Boolean(list.getAttribute('data-next-url'));
    var show = hasCollapsed || hasNext;
    button.hidden = !show;
    var footer = button.closest('.system-product-grid__footer');
    if (footer) footer.hidden = !show;
  }

  function applyVisibility(root) {
    var list = root.querySelector('#ProductsList');
    if (!list) return;
    var pageSize = Number(list.getAttribute('data-page-size')) || 20;
    var revealed = Number(list.dataset.revealed) || pageSize;
    var finish = currentFinish(root);
    var shown = 0;

    list.querySelectorAll(':scope > .product-column').forEach(function (column) {
      if (!columnHasFinish(column, finish)) {
        column.hidden = true;
        column.removeAttribute('data-collapsed');
        return;
      }
      column.hidden = false;
      if (shown < revealed) {
        column.removeAttribute('data-collapsed');
        shown += 1;
      } else {
        column.setAttribute('data-collapsed', 'true');
      }
    });

    syncHeadings(list);
    updateShowMore(root);
  }

  function filterColumns(list, finish) {
    list.querySelectorAll('.product-column').forEach(function (column) {
      column.hidden = !columnHasFinish(column, finish);
    });
    syncHeadings(list);
  }

  function sectionUrl(urlValue, root) {
    var url = new URL(urlValue, window.location.href);
    if (window.FoxTheme && window.FoxTheme.utils) {
      url.searchParams.set('section_id', window.FoxTheme.utils.getSectionId(root));
    }
    return url.toString();
  }

  function appendPage(list, root, urlValue) {
    return fetch(sectionUrl(urlValue, root))
      .then(function (response) {
        if (!response.ok) throw new Error('Could not load the next products');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var sourceList = parsed.querySelector('#ProductsList');
        if (!sourceList) throw new Error('Product list missing from the next page');
        sourceList.querySelectorAll(':scope > .product-column').forEach(function (column) {
          list.appendChild(column);
        });
        return sourceList.getAttribute('data-next-url') || '';
      });
  }

  function fetchRemaining(list, root) {
    var seen = {};
    var pages = 0;

    function next() {
      var nextUrl = list.getAttribute('data-next-url');
      if (!nextUrl || seen[nextUrl] || pages >= MAX_PAGES) return Promise.resolve(pages > 0);
      seen[nextUrl] = true;
      pages += 1;
      return appendPage(list, root, nextUrl).then(function (following) {
        list.setAttribute('data-next-url', following || '');
        return next();
      });
    }

    return next();
  }

  function settle(root) {
    var list = root.querySelector('#ProductsList');
    if (!list || !list.hasAttribute('data-group-by-component')) return;
    if (list.dataset.settled) return;
    list.dataset.settled = 'pending';

    var button = root.querySelector('[data-system-show-more]');
    var needsFetch = Boolean(list.getAttribute('data-next-url'));
    if (needsFetch) {
      list.classList.add('is-arranging');
      list.setAttribute('aria-busy', 'true');
      if (button) {
        button.classList.add('btn--loading');
        button.disabled = true;
      }
    }

    function finish() {
      if (!list.isConnected) return;
      regroup(list);
      if (!list.dataset.revealed) list.dataset.revealed = list.getAttribute('data-page-size') || '20';
      list.classList.remove('is-arranging');
      list.removeAttribute('aria-busy');
      if (button) {
        button.classList.remove('btn--loading');
        button.disabled = false;
      }
      applyVisibility(root);
      list.dataset.settled = 'true';
    }

    if (!needsFetch) {
      finish();
      return;
    }

    fetchRemaining(list, root)
      .catch(function () {})
      .then(finish);
  }

  function onFinish(root) {
    var list = root.querySelector('#ProductsList');
    if (!list) return;
    if (list.hasAttribute('data-group-by-component')) {
      if (list.dataset.settled !== 'true') return;
      list.dataset.revealed = list.getAttribute('data-page-size') || '20';
      applyVisibility(root);
      return;
    }
    filterColumns(list, currentFinish(root));
  }

  function onShowMore(root, button) {
    var list = root.querySelector('#ProductsList');
    if (!list || list.dataset.settled !== 'true') return;
    if (button.classList.contains('btn--loading')) return;

    var pageSize = Number(list.getAttribute('data-page-size')) || 20;
    var finish = currentFinish(root);
    var collapsedMatch = Array.from(list.querySelectorAll('.product-column[data-collapsed]')).some(function (column) {
      return columnHasFinish(column, finish);
    });

    if (collapsedMatch) {
      list.dataset.revealed = String((Number(list.dataset.revealed) || pageSize) + pageSize);
      applyVisibility(root);
      return;
    }

    var nextUrl = list.getAttribute('data-next-url');
    if (!nextUrl) {
      updateShowMore(root);
      return;
    }

    button.classList.add('btn--loading');
    button.disabled = true;
    appendPage(list, root, nextUrl)
      .then(function (following) {
        list.setAttribute('data-next-url', following || '');
        list.dataset.revealed = String((Number(list.dataset.revealed) || pageSize) + pageSize);
        regroup(list);
        applyVisibility(root);
      })
      .catch(function () {})
      .then(function () {
        button.classList.remove('btn--loading');
        button.disabled = false;
        updateShowMore(root);
      });
  }

  function boot() {
    document.querySelectorAll('[data-system-product-grid]').forEach(settle);
  }

  if (!window.__systemProductGridBound) {
    window.__systemProductGridBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-system-show-more]');
      if (!button) return;
      var root = button.closest('[data-system-product-grid]');
      if (!root) return;
      event.preventDefault();
      onShowMore(root, button);
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-system-product-finish]')) return;
      var root = event.target.closest('[data-system-product-grid]');
      if (!root) return;
      onFinish(root);
    });

    document.addEventListener('collection:rerendered', boot);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-system-product-grid]');
      if (root) settle(root);
    });
  }

  boot();
})();
